import React from "react";

function IndustryServices({ services }) {
  return (
    <section
      style={{
        padding: "100px 20px",
        background: "#f8fafc",
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        <h2
          style={{
            color: "#002147",
            marginBottom: "40px",
            textAlign: "center",
          }}
        >
          Recommended Services
        </h2>

        <div
          style={{
            display: "grid",
            gridTemplateColumns:
              "repeat(auto-fit,minmax(280px,1fr))",
            gap: "24px",
          }}
        >
          {services.map((service) => (
            <div
              key={service}
              className="premium-card"
              style={{
                padding: "30px",
                textAlign: "center",
              }}
            >
              <strong
                style={{
                  color: "#002147",
                }}
              >
                {service}
              </strong>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default IndustryServices;